import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46a11952"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex gap-4" }
const _hoisted_2 = { class: "borders" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Party ID", -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "borders" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "UID", -1))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "borders" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Account ID", -1))
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "borders" }
const _hoisted_13 = { class: "head" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "px-2" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "d-flex gap-4" }
const _hoisted_18 = { class: "borders" }
const _hoisted_19 = { class: "head" }
const _hoisted_20 = { class: "content" }
const _hoisted_21 = { class: "borders" }
const _hoisted_22 = { class: "head" }
const _hoisted_23 = { class: "content" }
const _hoisted_24 = { class: "borders" }
const _hoisted_25 = { class: "head" }
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "borders" }
const _hoisted_28 = { class: "head" }
const _hoisted_29 = { class: "content" }
const _hoisted_30 = { class: "borders" }
const _hoisted_31 = { class: "head" }
const _hoisted_32 = { class: "content" }
const _hoisted_33 = { class: "borders" }
const _hoisted_34 = { class: "head" }
const _hoisted_35 = { class: "content" }
const _hoisted_36 = {
  key: 1,
  class: "mt-6 px-2"
}
const _hoisted_37 = { class: "title" }
const _hoisted_38 = { class: "d-flex gap-4" }
const _hoisted_39 = { class: "borders" }
const _hoisted_40 = { class: "head" }
const _hoisted_41 = { class: "content" }
const _hoisted_42 = { class: "borders" }
const _hoisted_43 = { class: "head" }
const _hoisted_44 = { class: "content" }
const _hoisted_45 = { class: "borders" }
const _hoisted_46 = { class: "head" }
const _hoisted_47 = { class: "content" }
const _hoisted_48 = { class: "borders" }
const _hoisted_49 = { class: "head" }
const _hoisted_50 = { class: "content" }
const _hoisted_51 = { class: "borders" }
const _hoisted_52 = { class: "head" }
const _hoisted_53 = { class: "content" }
const _hoisted_54 = { class: "borders" }
const _hoisted_55 = { class: "head" }
const _hoisted_56 = { class: "content" }
const _hoisted_57 = { class: "d-flex gap-4 mt-4" }
const _hoisted_58 = { class: "borders" }
const _hoisted_59 = { class: "head" }
const _hoisted_60 = { class: "content" }
const _hoisted_61 = { class: "borders" }
const _hoisted_62 = { class: "head" }
const _hoisted_63 = { class: "content" }
const _hoisted_64 = { class: "borders" }
const _hoisted_65 = { class: "head" }
const _hoisted_66 = { class: "content" }
const _hoisted_67 = { class: "borders" }
const _hoisted_68 = { class: "head" }
const _hoisted_69 = { class: "content" }
const _hoisted_70 = { class: "borders" }
const _hoisted_71 = { class: "head" }
const _hoisted_72 = { class: "content" }
const _hoisted_73 = { class: "borders" }
const _hoisted_74 = { class: "head" }
const _hoisted_75 = { class: "content" }
const _hoisted_76 = { class: "borders" }
const _hoisted_77 = { class: "head" }
const _hoisted_78 = { class: "content" }
const _hoisted_79 = { class: "borders" }
const _hoisted_80 = { class: "head" }
const _hoisted_81 = { class: "content" }
const _hoisted_82 = {
  key: 3,
  class: "px-2"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Relationship", -1))
const _hoisted_84 = {
  key: 0,
  class: "d-flex gap-4"
}
const _hoisted_85 = { class: "borders" }
const _hoisted_86 = { class: "head" }
const _hoisted_87 = { class: "content" }
const _hoisted_88 = { class: "borders" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Direct IB ID", -1))
const _hoisted_90 = { class: "content" }
const _hoisted_91 = { class: "borders" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Direct Sales ID", -1))
const _hoisted_93 = { class: "content" }

import { ref, onMounted, watch } from "vue";
import AccountOverviewService from "@/projects/tenant/views/accountOverview/services/AccountOverviewServices";
import i18n from "@/core/plugins/i18n";
import { ServiceTypes } from "@/core/types/ServiceTypes";

export default /*#__PURE__*/_defineComponent({
  __name: 'accountInfo',
  props: {
  account: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { t } = i18n.global;
const isLoading = ref(false);
const data = ref<any>([]);

const fetchData = async () => {
  if (!props.account || !props.account.id) return;
  isLoading.value = true;
  try {
    const res = await AccountOverviewService.getAccountDetailById(
      props.account.id
    );
    data.value = res;
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    isLoading.value = false;
  }
};
watch(
  () => props.account,
  (newAccount, oldAccount) => {
    if (newAccount && newAccount.id !== oldAccount?.id) {
      fetchData();
    }
  },
  { deep: true }
);
onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_TimeShow = _resolveComponent("TimeShow")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(data.value?.partyId), 1)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(data.value?.uid), 1)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(data.value?.id), 1)
        ])
      ]),
      (data.value.accountNumber != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(data.value?.accountNumber), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_divider),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("fields.basicInfo")) + ":", 1),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("fields.userName")), 1),
          _createElementVNode("div", _hoisted_20, _toDisplayString(data.value?.name), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("fields.site")), 1),
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t(`type.siteType.${data.value?.siteId}`)), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("fields.accountType")), 1),
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t(`type.account.${data.value?.type}`)), 1)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("fields.accountRole")), 1),
          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t(`type.accountRole.${data.value?.role}`)), 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("fields.group")), 1),
          _createElementVNode("div", _hoisted_32, _toDisplayString(data.value?.group), 1)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
          _createElementVNode("div", _hoisted_35, [
            (data.value.createdOn != null)
              ? (_openBlock(), _createBlock(_component_TimeShow, {
                  key: 0,
                  "date-iso-string": data.value?.createdOn,
                  format: "YYYY-MM-DD"
                }, null, 8, ["date-iso-string"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (data.value.hasTradeAccount == true)
      ? (_openBlock(), _createBlock(_component_el_divider, { key: 0 }))
      : _createCommentVNode("", true),
    (data.value.hasTradeAccount == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t("fields.tradingAccountInfo")) + ":", 1),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
              _createElementVNode("div", _hoisted_41, _toDisplayString(data.value?.accountNumber), 1)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("fields.currency")), 1),
              _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(t)(`type.currency.${data.value.tradeAccount?.currencyId}`)), 1)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t("fields.platform")), 1),
              _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(ServiceTypes)[data.value.tradeAccount?.serviceId]), 1)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t("fields.group")), 1),
              _createElementVNode("div", _hoisted_50, _toDisplayString(data.value.tradeAccount.tradeAccountStatus?.group), 1)
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("fields.lastLogin")), 1),
              _createElementVNode("div", _hoisted_53, [
                (data.value.tradeAccount.tradeAccountStatus?.lastLoginOn != null)
                  ? (_openBlock(), _createBlock(_component_TimeShow, {
                      key: 0,
                      "date-iso-string": 
                data.value.tradeAccount.tradeAccountStatus?.lastLoginOn
              ,
                      format: "YYYY-MM-DD"
                    }, null, 8, ["date-iso-string"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("div", _hoisted_56, [
                (data.value.tradeAccount?.createdOn != null)
                  ? (_openBlock(), _createBlock(_component_TimeShow, {
                      key: 0,
                      "date-iso-string": data.value.tradeAccount?.createdOn,
                      format: "YYYY-MM-DD"
                    }, null, 8, ["date-iso-string"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t("fields.leverage")), 1),
              _createElementVNode("div", _hoisted_60, _toDisplayString(data.value.tradeAccount.tradeAccountStatus?.leverage), 1)
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t("fields.balance")), 1),
              _createElementVNode("div", _hoisted_63, _toDisplayString(data.value.tradeAccount.tradeAccountStatus?.balance), 1)
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t("fields.equity")), 1),
              _createElementVNode("div", _hoisted_66, _toDisplayString(data.value.tradeAccount.tradeAccountStatus?.equity), 1)
            ]),
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t("fields.margin")), 1),
              _createElementVNode("div", _hoisted_69, _toDisplayString(data.value.tradeAccount.tradeAccountStatus?.margin), 1)
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.$t("fields.marginLevel")), 1),
              _createElementVNode("div", _hoisted_72, _toDisplayString(data.value.tradeAccount.tradeAccountStatus?.marginLevel), 1)
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.$t("fields.marginFree")), 1),
              _createElementVNode("div", _hoisted_75, _toDisplayString(data.value.tradeAccount.tradeAccountStatus?.marginFree), 1)
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.$t("fields.credit")), 1),
              _createElementVNode("div", _hoisted_78, _toDisplayString(data.value.tradeAccount.tradeAccountStatus?.credit), 1)
            ]),
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.$t("fields.interestRate")), 1),
              _createElementVNode("div", _hoisted_81, _toDisplayString(data.value.tradeAccount.tradeAccountStatus?.interestRate), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (data.value.hasTradeAccount == true)
      ? (_openBlock(), _createBlock(_component_el_divider, { key: 2 }))
      : _createCommentVNode("", true),
    (data.value.hasTradeAccount == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
          _hoisted_83,
          _createElementVNode("div", null, [
            (data.value.role != 100)
              ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.$t("fields.referCode")), 1),
                    _createElementVNode("div", _hoisted_87, _toDisplayString(data.value?.referCode), 1)
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _hoisted_89,
                    _createElementVNode("div", _hoisted_90, _toDisplayString(data.value?.agentAccountId), 1)
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _hoisted_92,
                    _createElementVNode("div", _hoisted_93, _toDisplayString(data.value?.salesAccountId), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})